import { sendRequest } from '@uw/common-components/src/utils';
import { FEATURES_LIST, STATISTICS_ENDPOINT, API } from '../constants';

interface Features {
  [featureName: string]: boolean;
}

let enabledFeatures: Features = {};

export const useStatistics = () => {
  const { uid, services, account, widgetLayout, tunings } =
    UserWayWidgetApp.ContextHolder.config;

  const onFeatureTrigger = (
    feature: keyof typeof FEATURES_LIST,
    actionState?: string | number,
  ): void => {
    const featureCode = FEATURES_LIST[feature];

    if (!actionState && !enabledFeatures[featureCode]) {
      return;
    }

    enabledFeatures[featureCode] = actionState !== 0;
  };

  const sendStatistics = async () => {
    for (const feat in enabledFeatures) {
      const body = {
        uid: uid,
        siteId: services.siteId,
        account: account,
        type: services.paidAi ? 'paid' : 'free',
        feat,
        real: enabledFeatures[feat],
        widgetLayout: widgetLayout || tunings.widget_layout,
      };
      sendRequest(API + STATISTICS_ENDPOINT, 'POST', body);
    }
    enabledFeatures = {};
  };

  return {
    onFeatureTrigger,
    sendStatistics,
  };
};
